export default __webpack_public_path__ + "static/media/BackgroundStakeAzulComCarteira.89977dc4.png";